import {
  CompanyProfileExtendedFormFields,
  CompanyProfileFormFields,
} from '@pages/CompanyProfile/components/CompanyProfileModulesWrapper/types';
import { DocumentsFields } from '@services/requests/companyProfileService/types/mainData';

import { fieldDocumentsDependencies } from './constants';

interface UseRequiredDocumentsProps {
  defaultFormState: CompanyProfileFormFields & CompanyProfileExtendedFormFields;
  currentFormState: CompanyProfileFormFields & CompanyProfileExtendedFormFields;
}

function useRequiredDocuments({ currentFormState, defaultFormState }: UseRequiredDocumentsProps) {
  const changedKeys = Object.entries(defaultFormState)
    .map(([key, value]) => {
      return currentFormState[key] !== value ? key : null;
    })
    .filter((key) => key !== null);

  const requredDocuments = Array.from(
    new Set(
      Object.entries(fieldDocumentsDependencies)
        .filter(([fieldName]) => changedKeys.includes(fieldName))
        .map(([_, requiredDocuments]) => requiredDocuments)
        .flat()
    )
  );
  return requredDocuments;
}

export { useRequiredDocuments };
